import React from "react";

const ASP_Dictionary = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Dictionary</h1>
      <p>This is the ASP Dictionary page content.</p>
    </div>
  );
};

export default ASP_Dictionary;
